import { AnyAction } from 'redux';
import { GesamtpreisChanged, GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { App, BaseAppState } from '@ps20-frontend/frontend-models';

type OfferState = Pick<BaseAppState, 'angebotsId'>;

const isPriceOfAnotherOffer = (priceAngebotsId?: string, ownAngebotsId?: string): boolean =>
  !!priceAngebotsId && !!ownAngebotsId && priceAngebotsId !== ownAngebotsId;

export const gesamtbeitragReducer = function (
  sectionState = 0,
  action: AnyAction,
  app: App,
  angebotsId?: string,
): number {
  if (action.type === GlobalActions.GESAMTPREIS_CHANGED) {
    const actionPayload: GesamtpreisChanged = action.payload;
    if (
      actionPayload.triggeredByApp !== app ||
      isPriceOfAnotherOffer(actionPayload.angebotsId, angebotsId)
    ) {
      return sectionState;
    } else {
      return actionPayload.gesamtpreis;
    }
  }
  return sectionState;
};

export const gesamtbeitragReducerForApp = function (
  app: App,
): (sectionState: number, action: AnyAction, appState?: unknown) => number {
  return (sectionState: number, action: AnyAction, appState?: unknown) => {
    const { angebotsId } = (appState ?? {}) as OfferState;
    return gesamtbeitragReducer(sectionState, action, app, angebotsId);
  };
};
